import gql from 'graphql-tag';

export default gql`
  {
    getContact {
      id
      header_desktop
      header_mobile
      detail {
        title
      }
    }
  }
`;
